<script setup>
import { ref } from 'vue'
import i18n from '@/plugins/i18n'

const t = i18n.global.t

const text = ref('')
const dense = ref(false)

const emit = defineEmits(['filter'])
</script>

<template>
  <q-input
    v-model="text"
    bottom-slots
    :label="t('phonebook.search')"
    :dense="dense"
    debounce="500"
    @update:model-value="(val) => emit('filter', val, (newVal) => text = newVal)"
  >
    <template #append>
      <q-icon
        v-if="text !== ''"
        name="mdi-close"
        class="cursor-pointer"
        @click="() => emit('filter', '', (newVal) => text = newVal)"
      />
      <q-icon
        name="mdi-magnify"
      />
    </template>
  </q-input>
</template>
